import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire d'association code produit / provider
 * (`POST /ProductProviderMappings/add`, guide §6.4). `externalConfig` est
 * une configuration d'intégration sérialisée (JSON, défaut `{}`).
 *
 * Factory (règle projet) : créé via `createProductProviderMappingSchema()`
 * et mémoïsé au niveau composant sur la langue courante.
 */
export const createProductProviderMappingSchema = () =>
  z.object({
    productCodeId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") }),
    providerId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") }),
    externalConfig: z.string().trim().or(z.literal("")).optional(),
    isActive: z.boolean(),
  });

export type ProductProviderMappingFormValues = z.infer<
  ReturnType<typeof createProductProviderMappingSchema>
>;
